export default __webpack_public_path__ + "static/media/邝伟信半身像.9826d8b8.png";